module.exports = __webpack_public_path__ + "img/g5.ed0ee8af.jpg";